module.exports = __webpack_public_path__ + "static/media/S (40).b3d08079.jpg";